import { ReportsAndNotificationsComponent } from "./../../../webapp/src/app/configuration/components/reports-and-notifications/reports-and-notifications.component";
import { LanguageComponent } from "../../../webapp/src/app/configuration/components/language/language.component";
import { ProgressColoring } from "./services/progress-coloring";
import { BrandingCtrl } from "./controllers/branding";
import { BillingCtrl } from "./controllers/billing";
import { CancelSubscriptionCtrl } from "./controllers/cancel-subscription";
import { AccountNameOrDomainChangeCtrl } from "./controllers/account-name-or-domain-change";
import { ColoringCtrl } from "./controllers/coloring";
import { ConfidenceSettingsCtrl } from "./controllers/confidence-settings";
import { ChargebeeService } from "./services/chargebeeService";
import { FeatureUsageService } from "@gtmhub/configuration/services/featureUsageService";
import { EnvironmentService } from "@gtmhub/env";
import { SingleSignOnCtrl } from "./controllers/single-sign-on-ctrl";
import { RoleMappingCtrl } from "./controllers/role-mapping-ctrl";
import { SlackCtrl } from "./controllers/slack-ctrl";
import { JiraCtrl } from "./controllers/jira-ctrl";
import { TestConnectionCtrl } from "./controllers/test-connection-ctrl";
import { ConfigurationCtrl } from "./controllers/configuration-ctrl";
import { WorkdayConfigurationCtrl } from "./workday/workday-configuration-ctrl";
import { WorkdayUserProvisioningService } from "./workday/workday-user-provisioning-service";
import { SyncHistoryCtrl } from "./workday/sync-history/sync-history-ctrl";
import { WorkdaySettingsCtrl } from "./workday/workday-settings/workday-settings-ctrl";
import { SendInvitationEmailComponent } from "./workday/send-invitation-email/send-invitation-email.component";
import { WorkdayOperationsReportService } from "./workday/workday-operations-report-service";
import { WorkdayConnectorFormComponent } from "./workday/workday-connector-form/workday-connector-form.component";
import { SyncSelectionInfoComponent } from "./workday/sync-selection-info/sync-selection-info-ctrl";
import { ProvisioningCadenceComponent } from "./workday/provisioning-cadence/provisioning-cadence.component";
import { WizardCtrl } from "./workday/wizard/wizard-ctrl";
import { WizardProgressStepComponent } from "./workday/wizard/progress-step/progress-step.ctrl";
import { WizardSelectionsComponent } from "./workday/wizard/selections/selections.component";
import { WizardSelectionCtrl } from "./workday/wizard/selections/selection/selection-ctrl";
import { WizardFilterComponent } from "./workday/wizard/selections/selection/filter/fliter.component";
import { WizardSearchSelectAllComponent } from "./workday/wizard/selections/selection/filter/entires/search-select-all/search-select-all.component";
import { WizardOrganizationsFilterEntriesComponent } from "./workday/wizard/selections/selection/filter/entires/organizations-filter-entries/organizations-filter-entries.component";
import { WizardEntriesSelectorComponent } from "./workday/wizard/selections/selection/filter/entires/entries-selector/entries-selector.component";
import { OrganizationTeamMappingsComponent } from "./workday/wizard/mapping/organization-team-mappings/organization-team-mappings.component";
import { ManualOrganizationTeamMappingModalCtrl } from "./workday/wizard/mapping/manual-organization-team-mapping-modal/manual-organization-team-mapping-modal-ctrl";
import { ProvisioningComponent } from "./workday/wizard/provisioning/provisioning.component";
import { WizardMappingComponent } from "./workday/wizard/mapping/mapping.component";
import { ScimConfigurationComponent } from "./scim/scim-configuration.component";
import { CadenceComponent } from "./controllers/cadence.component";
import { downgradeComponent } from "@angular/upgrade/static";

const mod = angular.module("configuration", []);
mod.service("ProgressColoring", ProgressColoring);
mod.service("ChargebeeService", ChargebeeService);
mod.service("env", EnvironmentService);
mod.service("FeatureUsageService", FeatureUsageService);
mod.service("WorkdayUserProvisioningService", WorkdayUserProvisioningService);
mod.service("WorkdayOperationsReportService", WorkdayOperationsReportService);

mod.controller("SingleSignOnCtrl", SingleSignOnCtrl);
mod.controller("RoleMappingCtrl", RoleMappingCtrl);
mod.controller("SlackCtrl", SlackCtrl);
mod.controller("JiraCtrl", JiraCtrl);
mod.controller("TestConnectionCtrl", TestConnectionCtrl);
mod.controller("ConfigurationCtrl", ConfigurationCtrl);
mod.controller("ColoringCtrl", ColoringCtrl);
mod.controller("ConfidenceSettingsCtrl", ConfidenceSettingsCtrl);
mod.controller("BrandingCtrl", BrandingCtrl);
mod.controller("BillingCtrl", BillingCtrl);
mod.controller("CancelSubscriptionCtrl", CancelSubscriptionCtrl);
mod.controller("AccountNameOrDomainChangeCtrl", AccountNameOrDomainChangeCtrl);
mod.controller("WorkdayConfigurationCtrl", WorkdayConfigurationCtrl);
mod.controller("SyncHistoryCtrl", SyncHistoryCtrl);
mod.controller("WorkdaySettingsCtrl", WorkdaySettingsCtrl);
mod.controller("WizardCtrl", WizardCtrl);
mod.controller("WizardSelectionCtrl", WizardSelectionCtrl);
mod.controller("ManualOrganizationTeamMappingModalCtrl", ManualOrganizationTeamMappingModalCtrl);
mod.component("cadence", CadenceComponent);
mod.component("sendInvitationEmail", SendInvitationEmailComponent);
mod.component("provisioningCadence", ProvisioningCadenceComponent);
mod.component("workdayConnectorForm", WorkdayConnectorFormComponent);
mod.component("syncSelectionInfo", SyncSelectionInfoComponent);
mod.component("wizardEntriesSelector", WizardEntriesSelectorComponent);
mod.component("wizardOrganizationsFilterEntries", WizardOrganizationsFilterEntriesComponent);
mod.component("wizardSearchSelectAll", WizardSearchSelectAllComponent);
mod.component("wizardFilter", WizardFilterComponent);
mod.component("wizardProgressStep", WizardProgressStepComponent);
mod.component("organizationTeamMappings", OrganizationTeamMappingsComponent);
mod.component("wizardSelections", WizardSelectionsComponent);
mod.component("provisioning", ProvisioningComponent);
mod.component("wizardMapping", WizardMappingComponent);
mod.component("scimConfiguration", ScimConfigurationComponent);
mod.directive("languageConfiguration", downgradeComponent({ component: LanguageComponent }));
mod.directive("reportsAndNotifications", downgradeComponent({ component: ReportsAndNotificationsComponent }));

export default mod.name;
